
import { SWRConfiguration, SWRResponse } from "swr";

import { IReturn, GetConfigurationSourceDataAssignedAllocations, GetConfigurationSourceDataAssignedAllocationsResponse, ConfigurationSourceDataAllocation } from "@/api/dtos";
import { useMemo } from "react";
import useGet from "@/hooks/api/useGet";

const getData = (response?: SWRResponse<GetConfigurationSourceDataAssignedAllocationsResponse, GetConfigurationSourceDataAssignedAllocationsResponse>) => response?.data?.data;
const getError = (response?: SWRResponse<GetConfigurationSourceDataAssignedAllocationsResponse, GetConfigurationSourceDataAssignedAllocationsResponse>) => (response?.error ?? response?.data)?.responseStatus;
const getAdditionalState = (response?: SWRResponse<GetConfigurationSourceDataAssignedAllocationsResponse, GetConfigurationSourceDataAssignedAllocationsResponse>) => ({});

export const useConfigurationSourceDataAssignedAllocations = (configurationSourceDataId?: number, configuration?: SWRConfiguration | undefined) => {
    const request = useMemo(() => {
        if (!configurationSourceDataId) {
            return undefined;
        }

        return () => {
            return new GetConfigurationSourceDataAssignedAllocations({configurationSourceDataId});
        }
    }, [configurationSourceDataId]);

    return useGet(request, { getData, getError, getAdditionalState }, configuration);
}

export default useConfigurationSourceDataAssignedAllocations;